import React from "react";
import { Card, CardContent, Typography, Zoom } from "@mui/material";

export const TextBookChaptersAnimatedCard = ({
  card,
  index,
  handleCardClick,
}) => {
  const timeout = 500 + index * 200; // Adjust the timing as needed

  return (
    <Zoom in={true} timeout={timeout}>
      <Card
        key={index}
        onClick={() => handleCardClick(card)}
        style={{
          margin: "10px",
          cursor: "pointer",
          transition: "transform 0.3s",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
      >
        <CardContent>
          <Typography sx={{ mb: 0.5 }}>
            {"Chapter " + card.number}: {card.title}
          </Typography>
          {/* {card.topics && card.topics.length > 0 && (
            <div>
              <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "darkblue" }}>Topics:</Typography>
              <ul>
                {card.topics.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </div>
          )} */}
        </CardContent>
      </Card>
    </Zoom>
  );
};
